/* @flow weak */
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import React from 'react';
import Text from 'components/Text.jsx';

import './styles/EncryptionNotice.scss';

export default ({ className }) =>
  <Text color="thunder" className={cx('EncryptionNotice', className)}>
    <Glyph name="lock-stroke" className="EncryptionNotice-icon" />
    All data is encrypted and protected with bank-level security.
  </Text>;



// WEBPACK FOOTER //
// ./src/components/EncryptionNotice.jsx